export default "__VITE_ASSET__BAkW7Akw__"